<div class="item-tags" *ngIf="itemIcons.length > 0">
  <span class="tags" [theme]="options">{{ "contains" | translate }}&nbsp;</span>
  <span class="tags" [theme]="options" *ngFor="let icon of itemIcons;let i = index">
    <!-- <img [src]="getImageURL(icon)" /> -->
    {{ getIconName(icon) | translate}}
    <span *ngIf="i != itemIcons.length-1" class="dot"> &bull; </span>
  </span>
</div>
